import r from "./_tagTester.js";
import t from "./_has.js";
var e = r("Arguments");
!function () {
  e(arguments) || (e = function e(r) {
    return t(r, "callee");
  });
}();
var s = e;
export { s as default };